import db from 'database';
import Helpers, { findEarliestAvailableID } from 'shared/helpers';
import moment from 'moment';

export default class Resposta {
  id;
  _id;
  pem_id;
  pergunta_id;
  resposta;
  createdAt;
  updatedAt;
  deletedAt;

  /**
   *
   * @param {Object} data
   * @param {Number} data.pergunta_id
   * @param {Number} data.pem_id
   * @param {String} data.resposta
   * @param {String} [data.createdAt]
   * @param {String} [data.updatedAt]
   * @param {String} [data.deletedAt]
   */
  constructor(data) {
    Helpers.constructModel(data, this);
  }

  async save() {
    const curb = await db.respostas.filter(
      x =>
        String(x.pergunta_id) === String(this.pergunta_id) &&
        String(x.pem_id) === String(this.pem_id),
    );
    await curb.delete();
    this.updatedAt = moment()
      .toDate()
      .toISOString();
    this._id = await findEarliestAvailableID(db, 'respostas');
    return db.respostas.put(this);
  }

  static describe = () =>
    '++_id, pergunta_id, pem_id, resposta, createdAt, updatedAt, deletedAt';
}
